import {
	Component,
	inject,
	Injector,
	input,
	runInInjectionContext,
} from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { ModulesEnum } from '@splitsecondconnect/ultramarine-shared';
import { take } from 'rxjs';

import {
	StateBadgeComponent,
	StateBadgeEnum,
} from '../../../../../../../../../../shared/components/state-badge/state-badge.component';
import { UltraToolTipDirective } from '../../../../../../../../../../shared/directives/ulta-tooltip.directive';

@Component({
	selector: 'app-vehicle-links-status-button',
	templateUrl: './vehicle-links-status-button.component.html',
	styleUrls: ['./vehicle-links-status-button.component.scss'],
	imports: [StateBadgeComponent, TranslocoModule, UltraToolTipDirective],
	host: {
		class: 'contents',
	},
})
export class VehicleLinksStatusButtonComponent {
	recordData = input();
	#injector = inject(Injector);
	documentsLength = input<number>();
	stateBadgeEnum = StateBadgeEnum;
	emptyString = input();
	recordId = input<number>();
	selectedModule = input<any>();

	onAdd() {
		runInInjectionContext(this.#injector, () => {
			// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
			const resolver = inject(this.selectedModule().newRecordResolver) as any;
			resolver
				.resolve(
					null,
					this.selectedModule().newRecordComponent,
					this.selectedModule().newRecordPartialData(this.recordId()),
					ModulesEnum.VEHICLES,
				)
				.pipe(take(1))
				.subscribe();
		});
	}
}
